module.exports = __webpack_public_path__ + "static/media/upload.3607a115.svg";